// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeaderImage_wrapper__wPv6H","wrapperSquare":"HeaderImage_wrapperSquare__0tgsD","image":"HeaderImage_image__GeLNL","imageSquare":"HeaderImage_imageSquare__W54UR"};